;(function ( $ ) {

    /**
     *  submitOnChange
     *  submit parent form when control fires change event
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'submitOnChange';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.$form = $(this.element).parents('form');
            this.registerEvents();
        },
        registerEvents: function() {
            var _this = this;
            $(this.element).on('change', function() {
                _this.$form.submit();
                // $(document).trigger('overlay.showLoading');
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
